/**
 * formatDuration (NC-1294)
 *
 * Human duration for the run-runtime display ("Lief 2 h 13 min").
 *
 * Deliberately coarse: the display is a runtime, not a stopwatch. Seconds are
 * only shown below a minute, so a live-ticking value does not visibly churn and
 * the caller can tick at minute resolution instead of every second.
 *
 * Pure and total: any non-finite or negative input yields null rather than
 * "NaN min" (issue AC 2/3 — a legacy or still-scheduled run must never render a
 * broken number).
 */

const MS_MIN = 60_000;
const MS_HOUR = 60 * MS_MIN;
const MS_DAY = 24 * MS_HOUR;

export function formatDuration(ms: number | undefined | null): string | null {
  if (ms === undefined || ms === null) return null;
  if (!Number.isFinite(ms) || ms < 0) return null;

  if (ms < MS_MIN) return 'unter 1 min';

  const days = Math.floor(ms / MS_DAY);
  const hours = Math.floor((ms % MS_DAY) / MS_HOUR);
  const minutes = Math.floor((ms % MS_HOUR) / MS_MIN);

  if (days > 0) {
    const dayPart = days === 1 ? '1 Tag' : `${days} Tage`;
    return hours > 0 ? `${dayPart} ${hours} h` : dayPart;
  }
  if (hours > 0) {
    return minutes > 0 ? `${hours} h ${minutes} min` : `${hours} h`;
  }
  return `${minutes} min`;
}

export default formatDuration;
